"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var notification = document.createElement("div");
    var elemTitle = document.createElement("h2");
    var elemDescription = document.createElement("p");
    notification.classList.add("notification", type);
    elemTitle.classList.add("title");
    elemTitle.textContent = title;
    elemDescription.textContent = description;
    notification.style.top = posTop + "px";
    notification.style.right = posRight + "px";
    notification.appendChild(elemTitle);
    notification.appendChild(elemDescription);
    document.body.appendChild(notification);
    setTimeout(function() {
        notification.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.254e42cf.js.map
